import { useFormStore } from "./form.store";

export const setLoading = (value: boolean) => {
  useFormStore.setState({ loading: value });
};

export const setFieldError = (field: string, value: string) => {
  const errors = useFormStore.getState().errors;
  useFormStore.setState({
    errors: { ...errors, [field]: value },
  });
};

export const setFieldValue = (
  field: string,
  value: string | boolean | number
) => {
  const values = useFormStore.getState().values;
  useFormStore.setState({
    values: { ...values, [field]: value },
  });
};

export const createForm = (fields: string[]) => {
  fields.forEach((field) => {
    setFieldValue(field, "");
    setFieldError(field, "");
  });
};
